
import Data from "./Data";
import { useContext } from "react";
import Tabs from "./Tabs";
import TableUI from "./Table";
import TopHeading from "./TopHeading";
import { Container } from "react-bootstrap";
import { AppContext } from "../AppContext";


export default function Home({ setUpdate,update, }) {
  const { selectedToken, setSelectedToken } = useContext(AppContext);

  return (
    <Container className="container m-t-1 ">
      <TopHeading/>
      
      {/* Enhanced Token Toggle Switch */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '30px',
        marginTop: '25px',
      }}>
        <div style={{
          position: 'relative',
          background: '#d0d1d4',
          borderRadius: '50px',
          padding: '4px',
          display: 'inline-flex',
          boxShadow: '0 8px 24px rgba(102, 126, 234, 0.35), 0 2px 8px rgba(0,0,0,0.1)',
          backdropFilter: 'blur(10px)',
        }}>
          <div
            onClick={() => setSelectedToken("ICUSD")}
            onMouseEnter={(e) => {
              if (selectedToken !== "ICUSD") {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedToken !== "ICUSD") {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }}
            style={{
              position: 'relative',
              backgroundColor: selectedToken === "ICUSD" ? '#69b145' : '#c8cace',
              color: selectedToken === "ICUSD" ? '#ffffff' : '#868686',
              border: 'none',
              borderRadius: '46px',
              padding: '12px 32px',
              fontWeight: '700',
              fontSize: '15px',
              letterSpacing: '0.5px',
              cursor: 'pointer',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              marginRight: '4px',
              boxShadow: selectedToken === "ICUSD" ? '0 4px 16px rgba(255,255,255,0.3)' : 'none',
              transform: selectedToken === "ICUSD" ? 'scale(1.02)' : 'scale(1)',
              zIndex: selectedToken === "ICUSD" ? 2 : 1,
            }}
          >
            <span style={{ marginRight: '6px', fontSize: '16px' }}>$</span>
            ICUSD
          </div>
          <div
            onClick={() => setSelectedToken("ICEUR")}
            onMouseEnter={(e) => {
              if (selectedToken !== "ICEUR") {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedToken !== "ICEUR") {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }}
            style={{
              position: 'relative',
              backgroundColor: selectedToken === "ICEUR" ? '#2E5090' : '#c8cace',
              color: selectedToken === "ICEUR" ? '#ffffff' : '#868686',
              border: 'none',
              borderRadius: '46px',
              padding: '12px 32px',
              fontWeight: '700',
              fontSize: '15px',
              letterSpacing: '0.5px',
              cursor: 'pointer',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: selectedToken === "ICEUR" ? '0 4px 16px rgba(255,255,255,0.3)' : 'none',
              transform: selectedToken === "ICEUR" ? 'scale(1.02)' : 'scale(1)',
              zIndex: selectedToken === "ICEUR" ? 2 : 1,
            }}
          >
            <span style={{ marginRight: '6px', fontSize: '16px' }}>€</span>
            ICEUR
          </div>
        </div>
      </div>
  
      <div className="d-g g-t-c g-2 ">
        <div>
          <Data selectedToken={selectedToken} />
        </div>

        <div>
          <iframe
            id="geckoterminal-widget"
            title="GeckoTerminal Trading Chart"
            width="100%"
            height="500"
            src="https://www.geckoterminal.com/bsc/pools/0x8b74f51ee97c5cfa299f83257ff2aeda927982d95e0ecb1c9c172bbd631babf9?embed=1&info=0&swaps=0"
            style={{ border: 0 }}
            allow="clipboard-write"
          />

          <Tabs selectedToken={selectedToken} setUpdate={setUpdate} update={update} />
        </div>
      </div>
      <TableUI />
    </Container>
  );
}
